import $ from "jquery";

const downloadEStatementObj = {
  methods: {
    handleDataLayer:(e)=>{
        $(e).find('.download-e-statement--link-item').on('click', function(){
            let section = $(this).closest('.download-e-statement');
            let titleText = section.find('.download-e-statement--wrap h3').text().trim();
            let buttonText = $(this).text().trim();
            var obj = downloadEStatementObj.methods.downloadEObj(titleText,buttonText);
            createDataLayer('buttonClick', obj);
        });
    },

    init: function () {
        $('.download-e-statement').each((idx,ele)=>{
      downloadEStatementObj.methods.handleDataLayer(ele);
       });
    },

    downloadEObj : function(e,el) {
        var obj = {
            'articleName' : "",
            'blogCategory' : "",
            'blogPageCategory' : "",
            'buttonText' :  el ? el.replace(/\n/g, '').trim() : "",
            'pageSection' : e ? e : "Download E-Component",
            'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
            'planOption' : "",
            'productCategory' : "",
            'productName' : "",
            'question' : "",
            'source' : "",
            'searchTerm' : "",
            'videoTitle' : "",
            'bannerName' : "",
        };
        return obj;
    }
  },
 };

 $(() => {
  if ($(".download-e-statement").length > 0) {
 downloadEStatementObj.methods.init();
  }
});
